import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { type } from "arktype";
import { Pending } from "@/components/Pending";
import {
  AuthSlider,
  defaultSlides,
  northCarolinaNonprofitsSlides,
} from "../components/auth/AuthSlider";

const validateSearch = type({
  utm: "string?",
});

export const northCarolinaNonprofitsUtm = "ncnonprofits";
export const novemberOfferUtm = "novoffer";

export const utmTitles = {
  [northCarolinaNonprofitsUtm]:
    "Get Started with The North Carolina Center For Nonprofits Visa® Card",
  [novemberOfferUtm]:
    "November Offer — $150 Sign Up Bonus for New Organizations¹",
  default: "Get Started with Givefront",
};

export const Route = createFileRoute("/_unauthed")({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(
      context.trpc.auth.session.queryOptions(),
    );
    if (session.user) {
      throw redirect({
        to: "/dashboard",
      });
    }
  },
  component: RouteComponent,
  pendingComponent: Pending,
  validateSearch,
});

function RouteComponent() {
  const { utm } = Route.useSearch();

  return (
    <div className="fixed inset-0 grid lg:grid-cols-[40fr_60fr]">
      <div className="flex flex-col gap-4 overflow-auto sm:p-6 md:p-10">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="relative hidden bg-linear-to-r from-green-600 to-green-800 lg:block">
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <AuthSlider
            slides={
              utm === northCarolinaNonprofitsUtm
                ? northCarolinaNonprofitsSlides
                : defaultSlides
            }
          />
        </div>
      </div>
    </div>
  );
}
